module.exports = __webpack_public_path__ + "static/media/jt.c268bab5.png";